import {Component, Input, OnInit} from '@angular/core';
import {ChipConfig, ChipValue} from '../chips-list.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-chip-value',
  templateUrl: './chip-value.component.html',
  styleUrls: []
})
export class ChipValueComponent implements OnInit {

  @Input() value: ChipValue;
  @Input() config: ChipConfig;

  private readonly DEFAULTS = {
    allowRemoval: true
  };

  get removalAllowed(): boolean {
    return isNotNullOrUndefined(this.config.allowRemoval) ? this.config.allowRemoval : this.DEFAULTS.allowRemoval;
  }

  constructor() { }

  ngOnInit() {
  }

}
